import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// the translations
// (tip move them in a JSON file and import them)
const resources = {
  en: {
    translation: {
      'Welcome to React': 'Welcome to React and react-i18next',
    },
  },
};
let dfltLng = 'en';
try {
  const lSDataRaw = localStorage.getItem('persist:root');
  if (lSDataRaw) {
    const lSData = JSON.parse(lSDataRaw);
    if (lSData && lSData.loadz_auth) {
      const authReducer = JSON.parse(lSData.loadz_auth).AuthReducer;
      if (authReducer && authReducer.user && authReducer.user.language_code) {
        dfltLng = authReducer.user.language_code;
      }
    }
  }
} catch (e) {
  // fallback to default language
}
i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: dfltLng,

    keySeparator: false, // we do not use keys in form messages.welcome

    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
